/**
 * Heuristic over wallet/provider error shapes — `UserRejectedRequestError` et
 * al. share no common code across providers, but all match on name/message.
 * Feature-agnostic (not withdrawal-specific); mirrors @funkit/connect's
 * `utils/signature.ts`.
 */
export function isUserRejectedError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false
  }
  const regex = /user\s?rejected/gi
  return regex.test(error.name) || regex.test(error.message)
}

/**
 * Wallets name these rather than coding them — `SwitchChainError` or
 * `SwitchChainNotSupportedError`. Verbatim from @funkit/connect's
 * `utils/signature.ts` so both SDKs classify the same failure the same way.
 */
export function isSwitchChainError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false
  }
  const regex = /switch\s?chain/gi
  return regex.test(error.name) || regex.test(error.message)
}
